import { Link } from "react-router-dom";
import { LEGAL } from "../lib/legal";
import Logo from "./Logo";

const COLS = [
  { title: "Product", links: [["Find Parking", "/find"], ["Become a Host", "/host"], ["How It Works", "/#how-it-works"], ["Support", "/support"]] },
  { title: "Drivers", links: [["Search Parking", "/find"], ["My Bookings", "/bookings"], ["Wallet", "/wallet"], ["Notifications", "/notifications"]] },
  { title: "Hosts", links: [["List Your Space", "/host/listings/new"], ["Host Dashboard", "/host"], ["Payouts", "/payouts"], ["Host Bookings", "/host/bookings"]] },
  { title: "Company", links: [["Terms of Service", "/terms"], ["Privacy Policy", "/privacy"], ["Commercial Host Agreement", "/commercial-terms"], ["Legal", "/legal"], ["Contact", "/support"]] },
];

export default function Footer() {
  return (
    <footer className="border-t border-[#18181B] bg-[#050607]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-12">
          <div className="col-span-2 md:col-span-5">
            <Logo />
            <p className="mt-6 font-display font-medium text-xl text-zinc-200 tracking-tight">{LEGAL.tagline}</p>
            <p className="mt-3 text-sm text-zinc-500 leading-relaxed max-w-sm">
              A parking marketplace connecting drivers with local hosts. Payments processed securely by Stripe.
            </p>
          </div>
          {COLS.map((c) => (
            <nav key={c.title} aria-label={c.title} className="md:col-span-2">
              <h3 className="meta-label mb-5">{c.title}</h3>
              <ul className="space-y-3">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-zinc-500 hover:text-white transition-colors duration-200">{label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="mt-16 pt-7 border-t border-[#141619] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-zinc-600" data-testid="footer-copyright">{LEGAL.copyright}</p>
          <p className="text-xs text-zinc-700">{LEGAL.poweredBy}</p>
        </div>
      </div>
    </footer>
  );
}
